module.exports = __webpack_public_path__ + "img/emo_30.1e345b47.gif";